import { memo } from "react";
import { Outlet } from "react-router-dom";

export const Page = memo(function Page() {
  // const settings = useContext(SettingsContext);

  return <Outlet />;
});
